import { render, staticRenderFns } from "./InfoDataRFQ.vue?vue&type=template&id=cc7b8bb6&scoped=true&"
import script from "./InfoDataRFQ.vue?vue&type=script&lang=js&"
export * from "./InfoDataRFQ.vue?vue&type=script&lang=js&"
import style0 from "./InfoDataRFQ.vue?vue&type=style&index=0&id=cc7b8bb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7b8bb6",
  null
  
)

export default component.exports